import styled from "styled-components";

interface CheckboxWrapperProps {
  checked: boolean;
}

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  padding: 4px 2px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const StyledCheckbox = styled.div<CheckboxWrapperProps>`
  display: flex;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 2px solid #ccc;
  border-radius: 3px;
  background-color: ${(props) => (props.checked ? "#2c2c2c" : "transparent")};
`;

export const Checkmark = styled.div<CheckboxWrapperProps>`
  position: relative;
  border-radius: 3px;
  display: ${(props) => (props.checked ? "block" : "none")};
`;

export const CheckboxText = styled.span`
  font-size: 1rem;
  color: #2c2c2c;
  user-select: none;
`;
